
import React from 'react'
import classnames from 'classnames'
import { Button } from 'reactstrap'
import { useNavigate } from 'react-router-dom'
import { TabList, Tab } from 'react-tabs'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {
	faCarSide,
	faCommentsDollar,
	faCrutch,
	faHandSparkles,
	faImages,
	faListCheck,
	faPuzzlePiece,
	faTag
} from "@fortawesome/free-solid-svg-icons";

const AuctionsNavBar = ({ parentComponent, onSelect }) =>
{
	const navigate = useNavigate()

	const handleTabSelection = (componentName) =>
	{
		if (typeof onSelect === 'function')
		{
			onSelect(componentName)
			return
		}
		navigate(`/secure/${componentName}`)
	}

	return (
		<>
			<div className="nav-wrapper">
				<TabList className="nav nav-tabs" style={{ borderBottomColor: 'transparent', marginTop: '2rem' }}>
					<Tab className="nav-item">
						<Button
							outline
							className={
								"border-0 btn-transition btn-icon mb-2 me-2 " +
								classnames({ active: parentComponent === 'auction-detail' })
							}
							color="primary"
							onClick={ () => { handleTabSelection('auction-detail') } }
						>
							<FontAwesomeIcon icon={ faTag } /> Auction
						</Button>
					</Tab>
					<Tab className="nav-item">
						<Button
							outline
							className={
								"border-0 btn-transition btn-icon mb-2 me-2 " +
								classnames({ active: parentComponent === 'auction-bids' })
							}
							color="primary"
							onClick={ () => { handleTabSelection('auction-bids') } }
						>
							<FontAwesomeIcon icon={ faCommentsDollar } /> Bids & Offers
						</Button>
					</Tab>
					<Tab className="nav-item">
						<Button
							outline
							className={
								"border-0 btn-transition btn-icon mb-2 me-2 " +
								classnames({ active: parentComponent === 'auction-vehicle' })
							}
							color="primary"
							onClick={ () => { handleTabSelection('auction-vehicle') } }
						>
							<FontAwesomeIcon icon={ faCarSide } /> Vehicle
						</Button>
					</Tab>
					<Tab className="nav-item">
						<Button
							outline
							className={
								"border-0 btn-transition btn-icon mb-2 me-2 " +
								classnames({ active: parentComponent === 'auction-options' })
							}
							color="primary"
							onClick={ () => { handleTabSelection('auction-options') } }
						>
							<FontAwesomeIcon icon={ faPuzzlePiece } /> Options
						</Button>
					</Tab>
					<Tab className="nav-item">
						<Button
							outline
							className={
								"border-0 btn-transition btn-icon mb-2 me-2 " +
								classnames({ active: parentComponent === 'auction-condition' })
							}
							color="primary"
							onClick={ () => { handleTabSelection('auction-condition') } }
						>
							<FontAwesomeIcon icon={ faHandSparkles } /> Condition
						</Button>
					</Tab>
					<Tab className="nav-item">
						<Button
							outline
							className={
								"border-0 btn-transition btn-icon mb-2 me-2 " +
								classnames({ active: parentComponent === 'auction-damages' })
							}
							color="primary"
							onClick={ () => { handleTabSelection('auction-damages') } }
						>
							<FontAwesomeIcon icon={ faCrutch } /> Damages
						</Button>
					</Tab>
					<Tab className="nav-item">
						<Button
							outline
							className={
								"border-0 btn-transition btn-icon mb-2 me-2 " +
								classnames({ active: parentComponent === 'auction-pictures' })
							}
							color="primary"
							onClick={ () => { handleTabSelection('auction-pictures') } }
						>
							<FontAwesomeIcon icon={ faImages } /> Pictures
						</Button>
					</Tab>
					<Tab className="nav-item">
						<Button
							outline
							className={
								"border-0 btn-transition btn-icon mb-2 me-2 " +
								classnames({ active: parentComponent === 'auction-disclosures' })
							}
							color="primary"
							onClick={ () => { handleTabSelection('auction-disclosures') } }
						>
							<FontAwesomeIcon icon={ faListCheck } /> Disclosures
						</Button>
					</Tab>
				</TabList>
			</div>
		</>
	)
}

export default AuctionsNavBar
